export var HERO_BOTTOM_PADDING = {
  xs: 24,
  lg: 32
};
export var HERO_TITLE_PADDING = {
  xs: 4,
  sm: 8,
  lg: 12,
  xl: 16
};
export var HERO_KICKER_PADDING = {
  xs: 4,
  md: 8
};
export var HERO_LINK_PADDING = {
  xs: 20,
  md: 24,
  xl: 32
};
export var HERO_CENTER_BUTTON_PADDING = {
  xs: 16,
  md: 24
};
export var HERO_RIGHT_BUTTON_TOP_PADDING = {
  xs: 16,
  md: 24
};
export var HERO_RIGHT_BUTTON_LEFT_PADDING = {
  xs: 24,
  sm: 32,
  md: 40,
  xl: 48
};
export var HERO_CONTENT_PADDING = {
  xs: 8
};
export var HERO_HINT_PADDING = {
  xs: 16,
  md: 24
};
export var HERO_LIST_PADDING = {
  xs: 12,
  md: 16
};
export var HERO_LIST_HORIZONTAL_OFFSET = {
  xs: 20,
  sm: 24,
  md: 28,
  xl: 32
};
export var HERO_LIST_VERTICAL_OFFSET = {
  xs: 6,
  md: 12
};
export var HERO_PRICE_BOTTOM_MARGIN = {
  xs: 16,
  sm: 12,
  md: 14,
  lg: 16,
  xl: 18
};
export var HERO_BACKDROP_NORMAL_HEIGHT = {
  xs: '100%',
  sm: '85%',
  md: '75%',
  lg: '65%'
};
export var HERO_BACKDROP_CENTER_HEIGHT = '100%';
export var HERO_LINE_HORIZONTAL_SPACING = {
  xs: 20,
  sm: 24,
  md: 32
};
export var HERO_LINE_HORIZONTAL_LOGO_SPACING = {
  xs: 24,
  sm: 32,
  md: 40,
  lg: 48,
  xl: 54
};
export var HERO_LINE_VERTICAL_PADDING = {
  xs: 12,
  md: 16,
  xl: 24
};